export default function() {
  return document && document.uniqueID;
}



// WEBPACK FOOTER //
// ./src/scripts/lib/is_ie.js